import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { serviceList } from '../data/services/servicesRegistry';
import {
  homeScrollItem,
  homeScrollStagger,
  homeScrollViewport,
} from '../utils/homeScrollMotion';
import styles from './ServicesDetails.module.css';

const ServicesDetails = () => (
  <section className={styles.section} aria-label="Service offerings">
    <div className={styles.container}>
      <motion.header
        className={styles.head}
        variants={homeScrollItem}
        initial="hidden"
        whileInView="visible"
        viewport={homeScrollViewport}
      >
        <h2 className={styles.title}>
          Explore our <span className={styles.accent}>services</span>
        </h2>
        <p className={styles.sub}>
          Four capabilities from our Meerut facility — each opens a dedicated page with
          scope, advantages and how we support B2B buyers.
        </p>
      </motion.header>

      <motion.ul
        className={styles.mosaic}
        variants={homeScrollStagger}
        initial="hidden"
        whileInView="visible"
        viewport={homeScrollViewport}
      >
        {serviceList.map((service) => {
          const Icon = service.icon;

          return (
            <motion.li key={service.slug} variants={homeScrollItem}>
              <Link
                to={`/services/${service.slug}`}
                className={styles.tile}
                data-hue={service.hue}
              >
                <div className={styles.tileTop}>
                  <div className={styles.tileIdentity}>
                    <span className={styles.tileIcon} aria-hidden="true">
                      <Icon size={20} strokeWidth={2.2} />
                    </span>
                    <h3 className={styles.tileTitle}>{service.title}</h3>
                  </div>
                  <span className={styles.tileKicker}>{service.kicker}</span>
                </div>
                <p className={styles.tileHeadline}>{service.headline}</p>

                <div className={styles.tileCopy}>
                  <p className={styles.tileSummary}>{service.summary}</p>
                  {service.body?.[0] && (
                    <p className={styles.tileExtra}>{service.body[0]}</p>
                  )}
                  {service.body?.[1] && (
                    <p className={styles.tileExtra}>{service.body[1]}</p>
                  )}
                </div>

                <span className={styles.tileLink}>
                  Open service
                  <ArrowUpRight size={15} strokeWidth={2.5} aria-hidden="true" />
                </span>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>

      <motion.p
        className={styles.footnote}
        variants={homeScrollItem}
        initial="hidden"
        whileInView="visible"
        viewport={homeScrollViewport}
      >
        Bulk supply · custom specs · batch-wise QC · Pan-India logistics from one Meerut team.
      </motion.p>

      <motion.div
        className={styles.cta}
        variants={homeScrollItem}
        initial="hidden"
        whileInView="visible"
        viewport={homeScrollViewport}
      >
        <p className={styles.ctaText}>
          Need specs, timelines or a bulk quote? Our Meerut team responds within one business day.
        </p>
        <Link to="/contact" className={styles.ctaBtn}>
          Talk to our team
          <ArrowUpRight size={16} strokeWidth={2.5} aria-hidden="true" />
        </Link>
      </motion.div>
    </div>
  </section>
);

export default ServicesDetails;
